export default __webpack_public_path__ + "static/char-s-02-chs-0e676cde6c2e497c3560a1463625bf4e.webp";